// Taşeron portalı — bir modal kapandığında odağı onu AÇAN denetime geri veren TEK mekanizma
// (QA D2 ve D12 aynı kusurun iki ayrı yüzeyidir; üçüncüsü doğmasın diye tek yerde).
//
// Sebep mekaniktir, tercih değil: `packages/shared/src/ui/Modal.tsx` `Dialog.Trigger`
// KULLANMAZ (açma kararı her çağıranın kendi state'indedir). Radix'in modal `Dialog.Content`'i
// kapanışta `onCloseAutoFocus`'ta ÖNCE `event.preventDefault()` çağırır — bu, `FocusScope`'un
// kendi "önceki odağa dön" davranışını İPTAL EDER — sonra `context.triggerRef.current?.focus()`
// dener; `Trigger` olmadığı için o ref `null`'dur ve hiçbir şey odaklanmaz. Odaklı eleman
// DOM'dan kalktığı için tarayıcı odağı `<body>`'ye düşürür: tek bir `Tab` kullanıcıyı sayfanın
// en başına atar. Yani bu, TEK bir ekranın kusuru değil, bu app'teki HER `Modal` çağrısının
// kusurudur — her çağıran tetikleyicisini kendisi hatırlamak zorundadır.
//
// Kalıcı çözüm `Modal`'ın kendisindedir (açılışta `document.activeElement`i saklayıp kapanışta
// ona dönmek — çağıran tarafta hiçbir değişiklik gerektirmez ve üç portalı birden düzeltir); o
// dosya şu an ayrı bir karara kilitli olduğundan burada çağıran tarafında kapatılıyor.

import { useCallback, useRef } from 'react';

export interface ReturnFocus<T extends HTMLElement> {
  /** Sabit bir tetikleyiciye doğrudan bağlanır: `<Button ref={trigger.ref}>`. */
  ref: React.RefObject<T | null>;
  /** Satır başına DEĞİŞEN bir tetikleyici (tablodaki sil düğmesi) tıklama anında yazılır. */
  capture: (element: T | null) => void;
  /** Modal kapandığında çağrılır — odağı tetikleyiciye geri verir. */
  restore: () => void;
}

export function useReturnFocus<T extends HTMLElement = HTMLButtonElement>(): ReturnFocus<T> {
  const ref = useRef<T | null>(null);

  const capture = useCallback((element: T | null) => {
    ref.current = element;
  }, []);

  const restore = useCallback(() => {
    // Bir kare ertelenir: Radix'in unmount-autofocus'u kapanış commit'inden SONRA
    // (`setTimeout(…, 0)`) çalışır; sonraki karede yazmak kesin sonucu belirler. Tetikleyici bu
    // arada DOM'dan kalktıysa (satır silindi, şerit söndü) `focus()` sessizce hiçbir şey yapmaz.
    requestAnimationFrame(() => ref.current?.focus());
  }, []);

  return { ref, capture, restore };
}
